module.exports = __webpack_public_path__ + "static/3-hover-d40c6a2fd10309b8b3870e8a10b0f4ec.png";